"use client"

/**
 * El lado del navegador de lib/antispam/servidor.ts: el token de reCAPTCHA v3.
 *
 * EL SCRIPT DE GOOGLE NO SE CARGA AL ABRIR LA PAGINA, sino cuando alguien
 * empieza a rellenar un formulario (`prepararAntispam`, en el primer foco) o,
 * como tarde, al enviar. Las fichas de la guia tienen el formulario de opinion
 * y cargarlo en cada visita haria mas lentas miles de paginas que casi nadie
 * usa para opinar.
 *
 * Si no se puede cargar (bloqueador, sin red), devuelve null y el servidor
 * decide: en casi todos los formularios pide recargar; en las reservas deja
 * pasar con un limite mas corto.
 */

declare global {
  interface Window {
    grecaptcha?: {
      ready: (hecho: () => void) => void
      execute: (clave: string, opciones: { action: string }) => Promise<string>
    }
  }
}

const CLAVE = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY

let carga: Promise<boolean> | null = null

function cargar(): Promise<boolean> {
  if (!CLAVE || typeof window === "undefined") return Promise.resolve(false)
  if (window.grecaptcha) return Promise.resolve(true)
  if (!carga) {
    carga = new Promise<boolean>((resolver) => {
      const script = document.createElement("script")
      script.src = `https://www.google.com/recaptcha/api.js?render=${CLAVE}`
      script.async = true
      script.onload = () => resolver(Boolean(window.grecaptcha))
      script.onerror = () => {
        carga = null
        resolver(false)
      }
      document.head.appendChild(script)
    })
  }
  return carga
}

/** Empezar a cargar reCAPTCHA sin esperar. Para el primer foco del formulario. */
export function prepararAntispam() {
  void cargar()
}

/** El token para mandar con el formulario, o null si no se ha podido. */
export async function tokenAntispam(accion: string): Promise<string | null> {
  if (!(await cargar()) || !window.grecaptcha || !CLAVE) return null
  const grecaptcha = window.grecaptcha
  try {
    return await new Promise<string>((resolver, rechazar) => {
      grecaptcha.ready(() => {
        grecaptcha.execute(CLAVE, { action: accion }).then(resolver, rechazar)
      })
    })
  } catch {
    return null
  }
}
